import React from "react";
import "./About_journey.css";
import Common_heading from "../../common/common_heading/Common_heading";

function About_journey() {
  return (
    <section className="About_journey">
      <div className="container">
        <Common_heading
          title="Who We Are"
          subtitle="Every picture reflects growth, confidence, and achievement."
        />

        <div className="journey_content">
          <p>
            <strong>Diligencia Solutions &amp; Services Pvt. Ltd.</strong> is an
            India-based business services company specializing in data
            management and backend operational support services.
          </p>

          <p>
            We work with businesses of all sizes by providing scalable solutions
            that reduce operational workload while maintaining quality,
            confidentiality, and efficiency. Our objective is to become a
            trusted partner for organizations seeking dependable support
            services and process management.
          </p>

          <p>
            Our team combines expertise in information technology, operations
            management, project leadership, and financial services, enabling us
            to deliver professional and client-focused solutions.
          </p>
        </div>
      </div>
    </section>
  );
}

export default About_journey;
